/* unplugin-vue-components disabled */import { render } from "./ShareUserAgreements.vue?vue&type=template&id=f6e4a02c&scoped=true"
import script from "./ShareUserAgreements.vue?vue&type=script&lang=js"
export * from "./ShareUserAgreements.vue?vue&type=script&lang=js"

import "./ShareUserAgreements.vue?vue&type=style&index=0&id=f6e4a02c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e4a02c"]])

export default __exports__